import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { create_teamalias, update_teamalias } from '../api/api.js';
import { toast } from 'react-toastify';

const TeamAliasModal = forwardRef(({ isOpen, onClose, aliasdata }, ref) => {
  const [id, setId] = useState('');
  const [realName, setRealName] = useState('');
  const [alias, setAlias] = useState('');

  const [error, setError] = useState('');

  // Reset method
  useImperativeHandle(ref, () => ({
    reset: () => {
      setRealName('');
      setAlias('');

      setError('');
    },
    setup: (the_alias) => {
      setId(the_alias?.id);
      setRealName(the_alias?.real_name);
      setAlias(the_alias?.alias);

      setError('');
    }
  }));


  const handleUpdate = async () => {
    // Validazione semplice


    try {

      var data = {}
      data.id = id;
      data.real_name = realName;
      data.alias = alias;

      await update_teamalias(data.id, data);

      // Se tutto ok
      setError('');
      toast.success("Salvataggio avvenuto con successo");

      onClose();
    } catch (err) {
      setError('Errore durante la richiesta. Riprova.');
    }
  };





  const handleNext = async () => {
    // Validazione semplice
    if (
      !realName.trim() ||
      !alias.trim()
    ) {
      setError('Tutti i campi devono essere compilati.');
      return;
    }

    try {

      var data = {}
      data.realname = realName;
      data.alias = alias;


      await create_teamalias(data);

      // Se tutto ok
      setError('');
      onClose();
    } catch (err) {
      setError('Errore durante la richiesta. Riprova.');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container-big">
        <div className="modal-header">
          <h2 className="modal-title-document">{!!aliasdata ? "Modifica Alias": "Crea nuovo Alias"}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content-large">
          <div className="modal-body">
            <div className="modal-update-subtitle">Compila i campi dell'alias</div>

            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Nome</label>

            <input
              type="text"
              placeholder="Nome"
              value={realName}
              onChange={(e) => setRealName(e.target.value)}
              className="field-input"
            />

            </div>


            <div style={{marginBottom:"12px"}}>
            <label className="field-label">Alias</label>

            <input
              type="text"
              placeholder="Alias"
              value={alias}
              onChange={(e) => setAlias(e.target.value)}
              className="field-input"
            />

            </div>


            {error && <div className="modal-error">{error}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button className="footer-btn btn-secondary" onClick={onClose}>Indietro</button>
          <button className="footer-btn btn-primary longbutton" onClick={!!aliasdata ? handleUpdate : handleNext}>
            {!!aliasdata ? "Modifica Alias": "Crea Alias"}
          </button>
        </div>
      </div>
    </div>
  );
});

export default TeamAliasModal;
